export function stripHtmlToText(html) {
  if (html == null) return '';
  const s = String(html)
    .replace(/<[^>]*>/gi, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#39;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/\s+/g, ' ')
    .trim();
  return s;
}

export function truncateMetaDescription(text, maxLen = 160) {
  const t = String(text || '').trim();
  if (t.length <= maxLen) return t;
  return `${t.slice(0, Math.max(0, maxLen - 1)).replace(/\s+\S*$/, '')}…`.trim();
}

export function buildUniqueProductMeta({ id, title, description, titleSuffix = '' }) {
  const styleRef = `Style ${id}`;
  return {
    title: `${String(title || '').trim()} | ${styleRef}${titleSuffix}`,
    description: truncateMetaDescription(`${styleRef}. ${stripHtmlToText(description)}`),
  };
}
